import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  width: 51,
  height: 31,
  borderRadius: 16,
  backgroundColor: 'rgba(120,120,128,.16)',
  position: 'relative',
  cursor: 'pointer'
};

export const backgroundStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  borderRadius: 16,
  backgroundColor: 'black'
};

export const toggleStyle: CSSProperties = {
  width: 27,
  height: 27,
  borderRadius: 16,
  backgroundColor: 'white',
  boxShadow:
    '0 0 0 0.5px rgba(0,0,0,.04), 0 3px 8px 0 rgba(0,0,0,.15), 0 3px 1px 0 rgba(0,0,0,.06)',
  position: 'absolute',
  top: 2,
  left: 2
};